import { IPromise, IQService } from 'angular';
import { IDjangoFontFamily } from '../classes';

import DjangoClient, {
    IPagedResult,
} from '../../tn.django/django-client.service/djangoClient';
import { FontListParams, FontRepository } from './FontRepository';

/**
 * A repository for interacting with orders on the the server.
 * @param {object} djangoClient - Service that helps to perform HTTP calls
 * @return {$q} $q - Angular $q service
 */
export class FontFamilyRepository extends FontRepository {
    protected baseUri = '/api/1/families/';
    protected familyCache: Record<number, IDjangoFontFamily> = {};
    static $inject = ['djangoClient', '$q'];

    constructor(protected djangoClient: DjangoClient, protected $q: IQService) {
        super(djangoClient);
    }

    protected _filtersToParams(filters: FontListParams): URLSearchParams {
        const params = super._filtersToParams(filters);
        const id = filters.id?.join(',');
        if (id) params.set('id', id);
        if (filters.categories) {
            filters.categories.forEach((category) =>
                params.append('category', category.toString())
            );
        }
        if (filters.language) {
            filters.language.forEach((language) =>
                params.append('language', language.toString())
            );
        }
        if (filters.recommended_function) {
            filters.recommended_function.forEach((functionality) =>
                params.append('recommended_function', functionality.toString())
            );
        }
        if (filters.search) {
            params.set('search', filters.search);
        }

        if (filters.sort) {
            params.set('ordering', filters.sort);
        }
        return params;
    }

    public get(id: number): IPromise<IDjangoFontFamily> {
        if (this.familyCache[id]) {
            return this.$q.resolve(this.familyCache[id]);
        }
        return (super.get(id) as IPromise<IDjangoFontFamily>).then((family) => {
            this.familyCache[family.id] = family;
            return family;
        });
    }
    // https://api.typenetwork.com/api/1/families/recommended_size=700&recommended_size=800
    public list(
        filters: FontListParams
    ): IPromise<IPagedResult<IDjangoFontFamily>> {
        return (
            super.list(filters) as IPromise<IPagedResult<IDjangoFontFamily>>
        ).then((response) => {
            response.results.forEach((family) => {
                this.familyCache[family.id] = family;
            });
            return response;
        });
    }
}

export class FontFamilyPublicRepository extends FontFamilyRepository {
    protected baseUri = '/api/1/public/families/';

    protected _filtersToParams(filters: FontListParams): URLSearchParams {
        const params = super._filtersToParams(filters);
        const id = filters.id?.join(',');
        if (id) params.set('id', id);
        return params;
    }
}

export class FontFamilyPrivateRepository extends FontFamilyRepository {
    protected baseUri = '/api/1/private/families/';
}
